import { PromotionType } from '../types/offers';

const featuredOffesProcessor = (offers: PromotionType[]) => {
  const financeOffers = offers.filter((offer) => offer.offerType === 'finance');
  const cashOffers = offers.filter((offer) => offer.offerType === 'credit');
  const getUniqueByFamily = (items: PromotionType[], usedFamilies: string[] = []) => {
    return items.reduce((acc: PromotionType[], item) => {
      const family = item.offerModelDetail.modelFamily;
      if (
        !usedFamilies.includes(family) &&
        !acc.find((a) => a.offerModelDetail.modelFamily === family)
      ) {
        acc.push(item);
      }
      return acc;
    }, []);
  };
  const creditResult = getUniqueByFamily(cashOffers).slice(0, 2);
  const usedFamilies = creditResult.map((offer) => offer.offerModelDetail.modelFamily);
  const financeResult = getUniqueByFamily(financeOffers, usedFamilies).slice(0, 2);
  const result = [...creditResult, ...financeResult];
  if (result.length < 4) {
    const remainingUsedFamilies = result.map((offer) => offer.offerModelDetail.modelFamily);
    const remaining = getUniqueByFamily([...cashOffers, ...financeOffers], remainingUsedFamilies);
    return [...result, ...remaining.slice(0, 4 - result.length)];
  }
  return result;
};

// Function is to add some random offers into the featured section, if number of featured
// initially less than we expect

const getRandomFeaturedOffers = (offers: PromotionType[]) => {
  if (!offers.length) return [];
  const realFeaturedOffersList = offers.filter((offer) => offer.programPriority === 1);
  const regularOffers = offers.filter((offer) => offer.programPriority === 2);

  // Removing duplicated modelFamilies, and making offers unique, passing 2 credit and 2 finance in the perfect scenario
  const randomFeaturedOffers = featuredOffesProcessor(regularOffers);

  // If we have real featured offers - show them first, later the rest of offers
  const featuredOffers = [...realFeaturedOffersList, ...randomFeaturedOffers].slice(0, 4);

  return featuredOffers;
};

export default getRandomFeaturedOffers;
